var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kindeditor-component"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.outContent),expression:"outContent"}],attrs:{"id":_vm.id,"name":"content"},domProps:{"value":(_vm.outContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.outContent=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46915bda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component/KindEditor/Index.vue
// module id = null
// module chunks = 